import defaultStyled from '../../styled-components.mjs';

const TopLayerWrapperContainer = defaultStyled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2000;
`;

export { TopLayerWrapperContainer };
